import React, { useContext, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "../Components/Sidebar";
import AppInsight from "../AppInsight";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import HomeTable from "../Components/HomeTable";
import axios from "axios";
import SnackBar from "../Components/SnackBar";
import TopBar from "../Components/TopBar";
import { UserContext } from "../Hook/UserContext";
import useLoader from "../Hook/useLoader";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import IconButton from "@mui/material/IconButton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { fetchData, getEmail, getMSID, getName, getToken } from "../common";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { TextField } from "@mui/material";
import { Snackbar, Alert } from "@mui/material";

function Home() {
    const [data, setData] = useState([]);
    const {userRole,code1,setCode} = useContext(UserContext);
    let role = "";
    if (userRole === 1) {
        role = "admin";
    } else if (userRole === 2) {
        role = "auditor";
    }
    else if (userRole === 4) {
        role = "off-auditor";
    }else if(userRole === 3) {
        role = "off-admin";
    }
    let range = 90;
    const [totPending, setTotPending] = useState();
    const [totCompleted, setTotCompleted] = useState();
    const [totFallOut, setTotFallOut] = useState();
    const [pendingApproval, setPendingApproval] = useState();
    const [qaDone, setQaDone] = useState();
    const [sentBack, setSentBack] = useState();
    const [rejected, setRejected] = useState();
    const [pendingQA, setPendingQA] = useState();
    const [pendingReview, setPendingReview] = useState();
    const [users, setUsers] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const ddlDays = useRef(null);
    const [loader, showLoader, hideLoader] = useLoader();
    const [menuUsr, setMenuUsr] = React.useState(null);
    const openUsr = Boolean(menuUsr);
    const [selectionType, setSelectionType] =useState(()=>{
        return localStorage.getItem('filterType')||"days";
    });
    const [startDate, setStartDate] = useState(()=>{
        const savedStartDate=localStorage.getItem('startdate');
       return savedStartDate?dayjs(savedStartDate): dayjs().subtract(7, 'day')});
    const [endDate, setEndDate] = useState(()=>{
        const savedEndDate=localStorage.getItem('endDate');
       return savedEndDate?dayjs(savedEndDate): dayjs(new Date())});
    const [ranges, setRanges] = useState(()=>{
        const savedDays=localStorage.getItem('selectedDays');
        return savedDays?JSON.parse(savedDays):7});
    const msid = getMSID();
    const[previousDaysSelected,setPreviousDaysSelected]=useState(()=>{
        const savedDays=localStorage.getItem('selectedDaysPrevious');
        return savedDays?JSON.parse(savedDays):7});
    const [accessToken, setAccessToken] = useState('');
    const alertRef=useRef(null);
    const name = getName();
    const email = getEmail();
    const calculateDays = (days) => {
        const start = new Date();
        start.setDate(start.getDate() - days);
        return start;

    }
    const [input,setInput]=useState(()=>{
        const storeData=localStorage.getItem("claimNumberOrDrugName");
        const parseData=JSON.parse(storeData);
        return parseData?{ claimNumber: parseData.claimNumber,
        drugName:parseData.drugName}:{
        claimNumber: "",
        drugName:"",}
      });

   
    

    useEffect(()=>{
      localStorage.setItem('selectedDays',JSON.stringify(ranges));
      if(selectionType==='days'){
      localStorage.setItem('endDate',new Date());
      }
      else{
        localStorage.setItem('endDate',endDate);
      }
      localStorage.setItem('startdate',startDate);
      localStorage.setItem('selectedDaysPrevious',JSON.stringify(previousDaysSelected));
      localStorage.setItem('filterType',selectionType);
      if(input.claimNumber!==""){
      localStorage.setItem('claimNumberOrDrugName',JSON.stringify(input));
      }
      else if(input.drugName!==""){
        localStorage.setItem('claimNumberOrDrugName',JSON.stringify(input));
      }

       
    },[previousDaysSelected,ranges,startDate,endDate,input]);


    const resetDaysAndDateFilterState=()=>{
        localStorage.removeItem('selectedDays');
        localStorage.removeItem('endDate');
        localStorage.removeItem('startdate');
        localStorage.removeItem('selectedDaysPrevious');
        localStorage.removeItem('filterType');
        localStorage.removeItem('claimNumberOrDrugName');

    }

    const handleChange = (event) => {
        const selectedRange = parseInt(event.target.value, 10);
        setRanges(selectedRange);
        setStartDate(calculateDays(selectedRange));
        setEndDate(new Date());
        setPreviousDaysSelected(event.target.value);
    }

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        if (name === "claimNumber") {
          if (!/^\d*$/.test(value) && value.length <= 15)
            return;
        }
        setInput({ ...input, [name]: value});
      };

    function datediff(startDate, endDate) {
        return Math.round((startDate - endDate) / (1000 * 60 * 60 * 24));
    }


    const formatDate = (date) => {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        let year = d.getFullYear();
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return String([month, day, year].join('-'));
    }

    console.log("startdate",startDate)
    console.log("endDate",endDate)

    const formattedDateStart = startDate ? formatDate(startDate) : '';
    const formattedDateEnd = startDate ? formatDate(endDate) : '';
    const handleSelectionChange = (e) => {
        setSelectionType(e.target.value);
        const selectedRange = parseInt(previousDaysSelected,10);
        setRanges(selectedRange);
        setStartDate(calculateDays(selectedRange));
        setEndDate(new Date());  
    };
    const handleClickUsr = (event) => {
        setMenuUsr(event.currentTarget);
    };
    const handleCloseUsr = (event) => {
        setMenuUsr(null);
    };
    // const handleLogout = (event) => {
    //     setMenuUsr(null);
    //     const logoutRequest = {
    //         account: userDetail,
    //         postLogoutRedirectUri: process.env.REACT_APP_URL,
    //     };
    //     try {
    //         instance.logoutRedirect(logoutRequest);
    //     }
    //     catch (error) {
    //         AppInsight.trackEvent({ name: 'PNA Frontend => logOut Error => handleLogout => Home', properties: { errorMessage: error.message } });
    //     }
    // };

    useEffect(() => {
        try {
            callLandingPageApi(); 
        }
        catch (error) {
            if(alertRef.current)
                alertRef.current.showSnackbar();
            AppInsight.trackEvent({ name: `PNA Frontend => api token Error => useEffect Home Page, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    }, [])


    const callLandingPageApi = async () => {
        try {
            let days = datediff(endDate, startDate);
            if(selectionType==="claimNumber" &&input.claimNumber.length<15){
                if(alertRef.current)
                    alertRef.current.showSnackbar("Claim Number must be 15 digits","error");

            }
            else if(selectionType==="drugName" &&input.drugName.length===0){
                if(alertRef.current)
                    alertRef.current.showSnackbar("Sig and Notes field should not be blank","error");
                }
            else if(days > 90) {
                if(alertRef.current)
                    alertRef.current.showSnackbar( "Days difference between Start Date & End Date cannot be greater than 90 days!","error");
            }
            else {
                const token = getToken();
                const header = {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                };
                showLoader();
                AppInsight.trackEvent({ name: `PNA Frontend=>callLandingPageApi API Call started, msid=> ${msid}`});
                const response = await axios.get(process.env.REACT_APP_API_URI + "LandingPage?&id=" + msid + "&role=" + role +
                    "&from=" + formattedDateStart + "&to=" + formattedDateEnd +"&name=" + name + "&email="+email+"&key="+((selectionType==='date'||selectionType==='days')?"1":selectionType==='claimNumber'?"2":"3")+"&keyValue="+((selectionType==="claimNumber")?encodeURIComponent(input.claimNumber):((selectionType==="drugName")?encodeURIComponent(input.drugName):"")), header)
                AppInsight.trackEvent({ name: `PNA Frontend=>callLandingPageApi API Call completed, msid=> ${msid}`});

                    if (Object.hasOwn(response.data, 'error')) {
                    AppInsight.trackEvent({ name: `PNA Frontend => callLandingPageApi Error, msid=> ${msid}`, properties: { errorMessage: response.data.error } });
                    setShowTable(true);
                    if(alertRef.current)
                        alertRef.current.showSnackbar();
                    hideLoader();
                }
                else if (response.status === 200) {
                    if(response.data.gridData.length!==0){
                if(alertRef.current)
                    alertRef.current.CloseSnackbar();        
                setShowTable(true);
                setData(response.data.gridData);
                setTotCompleted(response.data.tilesData[0].totalClaimsCompleted);
                setTotPending(response.data.tilesData[0].totalClaimsInProgress);
                setTotFallOut(response.data.tilesData[0].totalClaimsFallout);
                setQaDone(response.data.tilesData[0].totalClaimsQADone);
                setPendingReview(response.data.tilesData[0].totalClaimsPendingReview);
                setRejected(response.data.tilesData[0].totalClaimsDenied);
                setSentBack(response.data.tilesData[0].totalClaimsSentBack);
                setUsers(response.data.userList);
                    }
                   else{
                    if(alertRef.current)
                        alertRef.current.showSnackbar("no results found","warning");
                        setShowTable(true);
                        setData([]);
                    }
                }
                hideLoader();
            }
        }
        catch (error) {
            
            hideLoader();
            if(alertRef.current)
                alertRef.current.showSnackbar();
            setShowTable(true);
        }
    };


    const handle = () => {
        setShowTable(true);
    };

    return (
        <div >
            {loader}
            <SnackBar ref={alertRef}/>
            <div className="container " style={{ margin: "0px", padding: "0px" }}>
                <div className="left-panel">
                    <Sidebar defaultValue="Home" />
                </div>
                <div className="right-panel">
                    <div id="main">
                        <TopBar role={role} />

                        <div className="main-content container-fluid">
                            <div className="card">
                                <div className="card-header-top justify-content-end align-items-center  marginBottomDayFilter" style={{marginLeft:'auto'}}>
                                    <h4 className="card-title"></h4>
                                    <div className="d-flex">
                                        <fieldset
                                            className="form-group paddingRight_10 marginRight2 home1"
                                        >
                                            <select
                                                value={selectionType}
                                                onChange={handleSelectionChange}
                                                className="form-select"
                                            >
                                                <option value="days" selected>
                                                    Days
                        </option>
                                                <option value="date">Date</option>
                                                <option value="claimNumber">Claim Number</option>
                                                <option value="drugName">Sig and Notes Fields</option>

                                            </select>
                                        </fieldset>
                                        {selectionType === "days"&&
                                            <fieldset className="form-group paddingRight_10 marginRight2" style={{width:'150px'}}>
                                                <select  value={ranges} onChange={handleChange} className="form-select">
                                                    <option value={7}>Last 7 Days</option>
                                                    <option value={15}>Last 15 Days</option>
                                                    <option value={30}>Last 30 Days</option>
                                                    <option value={45}>Last 45 Days</option>
                                                    <option value={90}>Last 90 Days</option>
                                                </select>
                                            </fieldset>
                                        }
                                         {selectionType === "date"&&
                                                <fieldset className="form-group paddingRight_10 marginRight2" style={{ height: '1%' }}>
                                                    <div class="col-md-4 cssChange" style={{ width: '50%' }}>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker label="Start Date"
                                                                onChange={(newValue) => setStartDate(newValue)}
                                                                format="MM-DD-YYYY"
                                                                value={dayjs(startDate)}
                                                            />
                                                        </LocalizationProvider>

                                                    </div>
                                                    <div class="col-md-4  cssChange cssChange1" style={{ width: '48%' }}>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker label="End date"
                                                                onChange={(newValue) => setEndDate(newValue)}
                                                                format="MM-DD-YYYY"
                                                                value={dayjs(endDate)}



                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                </fieldset>

                                            }
                                            {selectionType === "claimNumber"&&
                                             <fieldset className="form-group paddingRight_10 marginRight2" style={{ height: '1%' }}>
                                               <TextField
                                                // inputRef={(el)=>(selectTypeRef.current=el)}
                                                name="claimNumber"
                                                value={input.claimNumber}
                                                onChange={handleChangeInput}
                                                inputProps={
                                                    {
                                                        maxLength: 15,
                                                        style:{height:'0.4000em'},
                                                    }
                                                }

                                               />
                                         </fieldset>}
                                         {selectionType === "drugName"&&
                                             <fieldset className="form-group paddingRight_10 marginRight2" style={{ height: '1%' }}>
                                               <TextField
                                                // inputRef={(el)=>(selectTypeRef.current=el)}
                                                name="drugName"
                                                value={input.drugName}
                                                onChange={handleChangeInput}
                                                inputProps={
                                                    {
                                                        maxLength: 150,
                                                        style:{height:'0.4000em'},
                                                    }
                                                }


                                               />
                                         </fieldset>}
                                        <button id="btnGet" type="button" onClick={() => callLandingPageApi()} className="getResults" >Get Results</button>
                                    </div>
                                </div>
                            </div>
                            <section className="section marginLeft1">
                                <div className="row mb-2 marginLeft3 ">

                                    <div className="col-12 col-md-2 paddingLeftRightZero" >
                                        <div className="backgroundBlue borderRadius5">
                                        <div className="card card-statistic">
                                            <div className="card-body p-0">
                                                <div className="d-flex flex-column ">
                                                    <div className="px-3 py-2 d-flex">
                                                        <h3 className="card-title">
                                                            In-Progress
                            </h3>
                                                        <div className="card-right d-flex align-items-center">
                                                            <input
                                                                id="lbltotrequest"
                                                                type="text"
                                                                value={totPending}
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "white",
                                                                    fontFamily: "Arial",
                                                                    fontSize: "16px",
                                                                    border: "none",
                                                                    width: "50px",
                                                                    textAlign: "right",
                                                                    marginTop: '5%'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-2 paddingLeftRightZero" style={{width:'15%'}} >
                                    <div className="backgroundBlue borderRadius5" >

                                        <div className="card card-statistic">
                                            <div className="card-body p-0">
                                                <div className="d-flex flex-column ">
                                                    <div className="px-3 py-2 d-flex ">
                                                        <h3 className="card-title">
                                                            Completed
                            </h3>
                                                        <div className="card-right d-flex align-items-center">
                                                            <input
                                                                id="lblpending"
                                                                type="text"
                                                                value={totCompleted}
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "white",
                                                                    fontFamily: "Arial",
                                                                    fontSize: "16px",
                                                                    border: "none",
                                                                    width: "50px",
                                                                    textAlign: "right",
                                                                    marginTop: '5%',
                                                                    marginLeft:'16%'


                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    </div>
                                    <div className="col-12 col-md-2 paddingLeftRightZero"style={{width:'15%'}}>
                                    <div className="backgroundBlue borderRadius5">

                                        <div className="card card-statistic">
                                            <div className="card-body p-0">
                                                <div className="d-flex flex-column ">
                                                    <div className="px-3 py-2 d-flex ">
                                                        <h3 className="card-title">Sent Back</h3>
                                                        <div className="card-right d-flex align-items-center">
                                                            <input
                                                                value={sentBack}
                                                                id="lblapproved"
                                                                type="text"
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "white",
                                                                    fontFamily: "Arial",
                                                                    fontSize: "16px",
                                                                    border: "none",
                                                                    width: "50px",
                                                                    textAlign: "right",
                                                                    marginTop: '5%'

                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                   </div>
                                    </div>
                                    <div className="col-12 col-md-2 paddingLeftRightZero"style={{ width: '19%' }}>
                                    <div className="backgroundBlue borderRadius5">

                                        <div className="card card-statistic">
                                            <div className="card-body p-0">
                                                <div className="d-flex flex-column ">
                                                    <div className="px-3 py-2 d-flex ">
                                                        <h3 className="card-title">Pending Review</h3>
                                                        <div className="card-right d-flex align-items-center">
                                                            <input
                                                                id="lblapproved"
                                                                type="text"
                                                                value={pendingReview}

                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "white",
                                                                    fontFamily: "Arial",
                                                                    fontSize: "16px",
                                                                    border: "none",
                                                                    width: "50px",
                                                                    textAlign: "right",
                                                                    marginTop: '6%'

                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="col-12 col-md-2 paddingLeftRightZero"style={{width:'21.5%'}}>
                                    <div className="backgroundBlue borderRadius5">

                                        <div className="card card-statistic">
                                            <div className="card-body p-0">
                                                <div className="d-flex flex-column ">
                                                    <div className="px-3 py-2 d-flex ">
                                                        <h3 className="card-title">{(role === 'auditor'||role==='off-auditor') ? 'Rejected' : 'REQ FOR APPROVAL'}</h3>
                                                        <div className="card-right d-flex align-items-center">
                                                            <input
                                                                value={(role === 'auditor'||role==='off-auditor') ? rejected : qaDone}
                                                                id="lblapproved"
                                                                type="text"
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "white",
                                                                    fontFamily: "Arial",
                                                                    fontSize: "16px",
                                                                    border: "none",
                                                                    width: "50px",
                                                                    textAlign: "right",
                                                                    marginTop: '5%'

                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                   </div>
                                    </div>
                                    <div className="col-12 col-md-2 paddingLeftRightZero" style={{ width: '12.3%' }}>
                                    <div className="backgroundBlue borderRadius5">

                                        <div className="card card-statistic">
                                            <div className="card-body p-0">
                                                <div className="d-flex flex-column ">
                                                    <div className="px-3 py-2 d-flex">
                                                        <h3 className="card-title">Fallout</h3>
                                                        <div className="card-right d-flex align-items-center">
                                                            <input
                                                                value={totFallOut}
                                                                id="lblapproved"
                                                                type="text"
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "white",
                                                                    fontFamily: "Arial",
                                                                    fontSize: "16px",
                                                                    border: "none",
                                                                    width: "50px",
                                                                    textAlign: "right",
                                                                    marginTop: '5%'

                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                   </div>
                                    </div>
                                </div>

                                <div className="row  marginLeft3 marginBottomDayFilter">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-header d-flex justify-content-between align-items-center ">
                                                <h4 className="card-title ">Claim Documents</h4>
                                                <div className="d-flex "></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <HomeTable
                                data={data}
                                userList={users}
                                tableValue={showTable}
                                audited={totCompleted}
                                pending={totPending}
                                fallOut={totFallOut}
                                resetDaysAndDateFilterState={resetDaysAndDateFilterState}
                            />{" "}
                        </LocalizationProvider>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
